import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
// Class: GameInputHand
var GameInputHand = /** @class */ (function (_super) {
    __extends(GameInputHand, _super);
    function GameInputHand() {
        return _super.call(this) || this;
    }
    // Called whenever the class is initialized.
    GameInputHand.classInitializer = null;
    // List of static symbols to link.
    GameInputHand.classSymbols = null; // [];
    // List of instance symbols to link.
    GameInputHand.instanceSymbols = null; // [];
    GameInputHand.RIGHT = 'right';
    GameInputHand.LEFT = 'left';
    GameInputHand.UNKNOWN = 'unknown';
    return GameInputHand;
}(ASObject));
export { GameInputHand };
